import React from "react";
import clsx from "clsx";
import { Popover, Transition } from "@headlessui/react";
import { Button } from "..";
import { createMemoClass } from "../create-memo-class";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Dropdown = _ref => {
  var {
    label,
    disabled,
    leftIcon,
    rightIcon,
    color,
    size = "md",
    layout = "left",
    children
  } = _ref;
  var classes = useDropdownClass({
    layout
  });

  var Components = _ref2 => {
    var {
      children
    } = _ref2;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: React.Children.toArray(children).map((child, i) => /*#__PURE__*/_jsx(React.Fragment, {
        children: child
      }, i))
    });
  };

  return /*#__PURE__*/_jsxs(Popover, {
    className: classes,
    children: [/*#__PURE__*/_jsx(Popover.Button, {
      as: React.Fragment,
      children: /*#__PURE__*/_jsxs(Button, {
        className: "dropdown-button",
        color: color,
        size: size,
        disabled: disabled,
        children: [leftIcon ? leftIcon : null, label, rightIcon ? rightIcon : null]
      })
    }), /*#__PURE__*/_jsx(Transition, {
      as: React.Fragment,
      enter: "transition ease-out duration-200",
      enterFrom: "opacity-0 translate-y-1",
      enterTo: "opacity-100 translate-y-0",
      leave: "transition ease-in duration-150",
      leaveFrom: "opacity-100 translate-y-0",
      leaveTo: "opacity-0 translate-y-1",
      children: /*#__PURE__*/_jsx(Popover.Panel, {
        className: "dropdown-items",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full overflow-hidden rounded-container shadow-lg ring-1 ring-black ring-opacity-5",
          children: /*#__PURE__*/_jsx("div", {
            className: "relative grid bg-white",
            children: /*#__PURE__*/_jsx(Components, {
              children: children
            })
          })
        })
      })
    })]
  });
};
var useDropdownClass = createMemoClass(props => {
  var layouts = {
    left: "dropdown-left",
    right: "dropdown-right"
  };
  var classes = clsx("dropdown", layouts[props.layout]);
  return classes;
});
//# sourceMappingURL=dropdown.js.map